import { Button, styled, IconButton, Tooltip } from "@mui/material";
import React from "react";

const StyledButton = styled(({ children, isIconButton, ...props }) =>
  isIconButton ? (
    <IconButton variant="outlined" {...props}>
      {children}
    </IconButton>
  ) : (
    <Button variant="outlined" {...props}>
      {children}
    </Button>
  )
)(({ theme }) => ({
  boxSizing: "border-box",
  minHeight: "36px",
  // minWidth: "83px",
  border: "1px solid #dbdee6",
  borderRadius: "4px",
  background: "linear-gradient(180deg, #ffffff 0%, #f3f5f7 100%)",
  color: "#050D2E",
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "16px",
  textAlign: "center",
  textTransform: "none",
  ":hover": {
    border: "1px solid #dbdee6",
  },
}));

const PrimaryButton = React.forwardRef(({ children, ...props }, ref) => {
  const { tooltip } = props;

  const button = (
    <StyledButton {...props} ref={ref}>
      {children}
    </StyledButton>
  );
  return tooltip ? (
    <Tooltip title={tooltip}>
      <div>{button}</div>
    </Tooltip>
  ) : (
    button
  );
});
export default PrimaryButton;
